// extracted by mini-css-extract-plugin
export var changeIcon = "_59-4";
export var clickable = "_59-8";
export var container = "_59-0";
export var divider = "_59-7";
export var externalLinkIcon = "_59-1";
export var green = "_59-5";
export var helpCircleIcon = "_59-3";
export var iconButton = "_59-2";
export var red = "_59-6";